<template>
  <v-row>
    <v-col cols="auto">
      <v-dialog v-model="isOpen" max-width="600">
        <v-card>
          <v-card-title class="headline">
            {{ `Extrair tabela :: ${table}` }}
          </v-card-title>
          <v-card-text>
            <v-row class="mx-auto">
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required|max:255">
                  <v-text-field
                    id="titulo-extracao"
                    v-model="titulo"
                    placeholder="Informe o título da extração"
                    class="mt-8 mx-4 my-0"
                    label="Título"
                    outlined
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text color="primary" :disabled="disabled" :loading="loading" @click="save">Salvar</v-btn>
            <v-btn color="primary" text @click="closeDialog">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import ExtracoesBdgdService from '@/services/ExtracoesBdgdService';

  export default {
    name: 'DialogSaveDataBdgd',

    props: {
      table: {
        type: String,
        default: () => null
      },
      params: {
        type: Object,
        default: () => {}
      },
      dialog: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        titulo: null,
        loading: false
      };
    },

    computed: {
      isOpen: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        }
      },
      disabled() {
        return !this.titulo;
      },
      companyId() {
        return this.$store.getters.getCompanyId;
      }
    },

    methods: {
      save() {
        this.loading = true;

        const saveData = {
          titulo: this.titulo,
          tabela: this.params.tabela,
          query: this.params.query,
          company_id: this.companyId,
          bdgd_versao_id: this.params.bdgdId
        };

        return ExtracoesBdgdService.save(saveData)
          .then(() => {
            this.$toast.success('Extração BDGD salva com sucesso.', '', {
              position: 'topRight'
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar a extração BDGD.', '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading = false;
            this.closeDialog();
          });
      },
      closeDialog() {
        this.isOpen = false;
      }
    },

    watch: {
      table() {
        this.titulo = this.table;
      }
    }
  };
</script>